<template>
  <textarea :id="thisId">

  </textarea>
</template>

<script>
import 'tinymce'
/*
import 'tinymce/themes/modern/theme.js'
import 'tinymce/skins/lightgray/skin.min.css'
import 'tinymce/skins/lightgray/content.min.css'
import 'tinymce/plugins/advlist/plugin.js'
import 'tinymce/plugins/autolink/plugin.js'
*/
import Vue from 'vue'
	Vue.directive('tinymce-abs',{ 
  	twoWay: true,
    inserted: function(el, binding, vnode) {
      var self = el
      var selec = el.id
      console.log("CI ARRIVO ")
      console.log(this)
      tinymce.init({
      	selector: '#'+el.id,
        setup: function(editor) {
        console.log("SETUP TINYMCE________")
        console.log(el.value)
        	// init tinymce
        	editor.on('init', function() {
            if(typeof el.value !==undefined && el.value!='')
                tinymce.get(el.id).setContent(el.value);
          });
          
          // when typing keyup event
          editor.on('keyup change', function(e) {
          	//console.log(el.id)
            // get new value
          	var new_value = tinymce.get(el.id).getContent();
            //console.log(new_value)
            // set model value
            el.value = new_value
            
            //console.log(el.value)
          });
          
        }
      });
    },
    unbind:function(){
      tinymce.remove()
    },
    update: function(newVal, oldVal) {
    	// set val and trigger event
    	//$(this.el).val(newVal).trigger('keyup');
      console.log(newVal)
    }
  
  })


export default {
  props: ['height','language','initvalue'],
  created () {
    console.log("TINYMCE CREATO");
    this.thisId="tinymce-"+Math.floor((Math.random() * 10000) + 1)
  },  
  mounted (){
      this.tinymceInit()
    
  },
  destroyed(){
    tinymce.remove()
  },
  watch: {
    '$teras.language':  'terasChange'
  },
  methods: {
    terasChange(){
        tinymce.remove()
      //tinymce.init({language : self.$teras.language})
      console.log("DA ABS" + this.$teras.language)
      //tinyMCE.execCommand(“mceRepaint”);
      var self = this
      tinyMCE.execCommand("mceRepaint")
      this.tinymceInit()
    },
    tinymceInit(){
        var self = this
        console.log("MOUNTED ABS-TINYMCE "+this.height)
        console.log(self.$el.id)
        console.log(self.$teras.language)
        //tinyMCE.baseURL = "https://cdn.tinymce.com/4"
        tinyMCE.baseURL = "https://cloud.tinymce.com/stable"
        this.tiny = tinymce.init({
            selector: '#'+self.$el.id,
            menubar: false,
            height: self.height,
            language : self.$teras.language,
            language_url : '/bams/langs/it.js',
            oninit : "setPlainText",
            entity_encoding : "raw",
            forced_root_block : false,
            valid_elements : 'sup,sub,br',

            //relative_urls : false,
            //document_base_url: "http://cdn.tinymce.com/4",

            plugins: [
            'paste',
            'charmap',
            'wordcount,fullscreen',
            'contextmenu ',
            ''
            ],
            contextmenu: "charmap | subscript  superscript | copy paste",
            //toolbar1: 'undo redo |  styleselect | bold italic | subscript  superscript | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | charmap | fullscreen',
            toolbar1: 'undo redo |   subscript  superscript |  charmap | fullscreen',
            //toolbar2: 'insert | print preview media | forecolor backcolor emoticons | codesample',

            setup: function(editor) {
            console.log("SETUP TINYMCE")
            console.log(self.$el.id)
                // init tinymce
                editor.on('init', function() {
                if(typeof self.initValue!==undefined)
                 tinymce.get(self.$el.id).setContent(self.initvalue);

                var theEditor = tinymce.activeEditor
                var wordCount = theEditor.plugins.wordcount.getCount()
                var new_value = tinymce.get(self.$el.id).getContent()
                self.$emit('input', new_value)
                self.$emit('change', new_value, wordCount)
            });
            
            // when typing keyup event
            editor.on('keyup change', function(e) {
                
                var theEditor = tinymce.activeEditor
                var wordCount = theEditor.plugins.wordcount.getCount()

                var new_value = tinymce.get(self.$el.id).getContent()
                /*self.$el.value = new_value */
                self.$emit('input', new_value)
                self.$emit('change', new_value, wordCount)
                
                //console.log(new_value)
            });
            
            }
        })
        console.log(this.tiny)
        console.log("FINITA")
      }
  }
  
}

</script>
<style>
.inside-top{
  background:#fff url(/2017/documenti/backInside.png) no-repeat center center;
  width: 100%;
  height:275px;
  border-top:2px solid #fff;
}
.page-inside{

}
.page-inside h3.title{
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// Abs-tinymce.vue?69f22f89